import { UserCreatePage } from "~/domain/common";
import { DsmNavigation } from "../../DsmNavigation";

export function DsmUserCreatePage() {
  return <UserCreatePage navigation={<DsmNavigation />} />;
}
